























import { Vue, Component, Prop } from 'vue-property-decorator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({
  components: { NewTranslation },
})
export default class SplashFooter extends Vue {
  @Prop(Boolean)
  communeSelected!: boolean;
  @Prop({ default: false })
  locationView!: boolean;

  public get communeId() {
    return this.$route.params.communeId || 0;
  }
}
